export const UPDATE_CUSTOMER_ERROR = "UPDATE_CUSTOMER_ERROR";
export const AVANTIO_INTEGRATION_ERROR = "AVANTIO_INTEGRATION_ERROR";
